import InputGroup from "../form/InputGroup";
import React, {useEffect, useState} from "react";
import {Button, TextInput} from "omoplay";
import {getSettings, saveSettings} from "../../api/account/account.api";


const GeneralSettings = () => {
    const [phoneNumber, setPhoneNumber] = useState(null)
    const [unitPrice, setUnitPrice] = useState("0")

    useEffect(() => {
        getSettings().then(({data}) => {
            setPhoneNumber(data.phoneNumber)
            setUnitPrice(data.unitPrice)
        })
    }, []);

    return (
        <>
            <div className="flex-col gap-[36px] max-w-[1200px]">
                <div className="flex-col gap-2">
                    <InputGroup label="관리자 연락처" description="AI 리포트 및 알림톡을 받을 연락처를 입력 해주세요.">
                        <TextInput placeholder="휴대전화 번호" value={phoneNumber}
                                   onChange={(e) => setPhoneNumber(e.target.value)} />
                    </InputGroup>
                    <InputGroup label="객단가" description="고객당 평균 구매 금액을 입력 해주세요.">
                        <TextInput type="numeric" placeholder="12000" value={unitPrice}
                                   onChange={(e) => setUnitPrice(e.target.value)} />
                    </InputGroup>
                </div>
                <div className="flex justify-end">
                    <Button variants="primary" size="large" value="저장하기" onClick={() => {
                        saveSettings(phoneNumber, unitPrice).then(() => {
                            alert("저장 되었습니다.")
                        })
                    }} style={{width: "160px"}} />
                </div>
            </div>
        </>
    )
}

export default GeneralSettings